<template>
<div>
  <update-information-modal
      v-if="isAddEditModalActive"
      :preloader="deleteLoader"
      :table-id="tableId"
      :acc-app-id="accAppId"
      :activity="activity"
      @close-modal="closeAddEditModal"
    />
  <app-table :id="tableId" :options="options" @action="getListAction" />
</div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";
export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      deleteLoader: false,
      tableId: "update-information-table",
      rowData: {},
      accAppId:"",
      statusId:"",
      activity:"",
      options: {
        name: "update-information-table",
        url: `/qualityMng/updateInformations/index`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Alcance"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("PDF"),
            icon: "download",
            type: "none",
          },
          {
            title: this.$t("Resolución"),
            icon: "file-text",
            type: "none",
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.$hub.$on("reload-table", () => {
      this.$hub.$emit("reload-" + this.tableId);
    });
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.data();
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#modal-add-edit-update-inf").modal("hide");
      this.isAddEditModalActive = false;
    },
    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("Alcance")) {
        this.accAppId = rowData.id;
      this.activity = rowData.accreditation_activity.code;
      this.openAddEditModal();
      } else if (actionObj.title == this.$t("PDF")) {
        this.accAppId = rowData.id;
        this.statusId = rowData.status.id;
        this.openTab('pdf', 'active');
      } else if (actionObj.title == this.$t("Resolución")) {
        this.openTabRe(rowData.subscribed_accreditation_resolution.path);
      }
    },
    openTab(type, tableName) {
      const url = `/common/scopes/exportActiveScopes?
        type=${type}
        &accAppId=${this.accAppId}
        &statusId=${this.statusId}
        &tableName=${tableName}`;
      window.open(url, "_blank").focus();
    },

    openTabRe(path) {
      window.open(path, "_blank").focus();
    },

    data() {},
  },
};
</script>
